import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/css/index.css';
import { installMachineTranslationSafety } from './utils/machineTranslationSafety';

// Must run before React mounts: it patches the two DOM calls React uses to
// move nodes around, so a browser translator cannot crash a screening.
installMachineTranslationSafety();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
